import { Navbar } from './ui/Navbar';
import { PuzzleCard } from './ui/PuzzleCard';
import { ApiClient } from './core/ApiClient';
import { i18n } from './core/I18nManager';
import './styles/main.css';

class SearchPage {
    private navbar!: Navbar;
    private currentSearch: string = '';
    private currentPage: number = 1;
    private itemsPerPage: number = 12;
    private selectedPictureId: string | null = null;

    constructor() {
        this.init();
    }

    private async init() {
        await i18n.init();
        
        const navbarRoot = document.getElementById('navbar-root');
        if (navbarRoot) {
            this.navbar = new Navbar(navbarRoot);
        }

        // 解析 URL 参数
        const params = new URLSearchParams(window.location.search);
        this.currentSearch = params.get('q') || '';
        this.currentPage = parseInt(params.get('page') || '1');

        if (this.currentSearch) {
            const queryDisplay = document.getElementById('search-query-text');
            if (queryDisplay) queryDisplay.textContent = `“${this.currentSearch}” 的搜索结果`;
            this.renderResults();
        } else {
            window.location.href = 'index.html';
        }

        this.bindEvents();
    }

    private async renderResults() {
        const grid = document.getElementById('pictureGrid');
        if (!grid) return;

        grid.style.opacity = '0.5';

        try {
            const data = await ApiClient.get<any>('/api/puzzle/list', {
                search: this.currentSearch,
                page: this.currentPage.toString(),
                limit: this.itemsPerPage.toString()
            });

            const puzzles = data.puzzles;
            const stats = document.getElementById('search-stats');
            if (stats) stats.textContent = `共找到 ${data.total_count} 个相关拼图`;

            if (puzzles.length === 0) {
                grid.innerHTML = `<div class="col-span-full py-20 text-center text-stone-400">未找到相关结果</div>`;
            } else {
                grid.innerHTML = puzzles.map((pic: any) => PuzzleCard.render(pic)).join('');

                grid.querySelectorAll('.puzzle-card').forEach(card => {
                    card.addEventListener('click', () => {
                        this.selectedPictureId = (card as HTMLElement).dataset.id || null;
                        this.openDifficultyModal();
                    });
                });
            }

            this.updatePagination(data.has_more, data.total_count);
            grid.style.opacity = '1';
        } catch (e) {
            grid.innerHTML = `<p class="col-span-full py-10 text-center text-red-400">加载失败</p>`;
        }
    }

    private updatePagination(hasMore: boolean, total: number) {
        const container = document.getElementById('paginationControls');
        if (!container) return;

        const totalPages = Math.ceil(total / this.itemsPerPage);
        if (totalPages <= 1) {
            container.innerHTML = '';
            return;
        }

        container.innerHTML = `
            <div class="flex items-center justify-center gap-6">
                <button id="prevPage" class="w-10 h-10 flex items-center justify-center rounded-full border border-stone-200 bg-white hover:bg-stone-50 disabled:opacity-30" ${this.currentPage === 1 ? 'disabled' : ''}>
                    <iconify-icon icon="solar:arrow-left-linear" width="20"></iconify-icon>
                </button>
                <span class="text-sm font-medium">${this.currentPage} / ${totalPages}</span>
                <button id="nextPage" class="w-10 h-10 flex items-center justify-center rounded-full border border-stone-200 bg-white hover:bg-stone-50 disabled:opacity-30" ${!hasMore ? 'disabled' : ''}>
                    <iconify-icon icon="solar:arrow-right-linear" width="20"></iconify-icon>
                </button>
            </div>
        `;

        container.querySelector('#prevPage')?.addEventListener('click', () => {
            this.updateUrl(this.currentPage - 1);
        });
        container.querySelector('#nextPage')?.addEventListener('click', () => {
            this.updateUrl(this.currentPage + 1);
        });
    }

    private updateUrl(page: number) {
        window.location.href = `search.html?q=${encodeURIComponent(this.currentSearch)}&page=${page}`;
    }

    private bindEvents() {
        document.getElementById('startGameBtn')?.addEventListener('click', () => {
            if (!this.selectedPictureId) return;
            const difficulty = (document.querySelector('.diff-option.selected') as HTMLElement)?.dataset.diff || 'easy';
            window.location.href = `game.html?id=${this.selectedPictureId}&difficulty=${difficulty}`;
        });

        document.querySelectorAll('.diff-option').forEach(opt => {
            opt.addEventListener('click', () => {
                document.querySelectorAll('.diff-option').forEach(o => o.classList.remove('selected'));
                opt.classList.add('selected');
            });
        });

        window.addEventListener('nav-search', (e: any) => {
            window.location.href = `search.html?q=${encodeURIComponent(e.detail)}`;
        });
    }

    private openDifficultyModal() {
        document.getElementById('difficultyModal')?.classList.add('active');
    }
}

new SearchPage();
